//import React from "react";
import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import withRouter from "components/Common/withRouter";

import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Input,
  Row,
  Button
} from "reactstrap"

import { ToastContainer } from "react-toastify";

// import images
import logodark from "../../assets/images/logo-yeta.png"
import logolight from "../../assets/images/logo-yeta.png"


import {
    verifyForgetPassword as onVerifyForgetPassword,
    resendForgetPasswordCode as onResendForgetPasswordCode,
   


  
} from "store/actions";


//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";



const VerifyForgetPassword = (props) => {

  

  //meta title
  document.title = "Vérification  | SIGUNIV";

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [error, setError] = useState("");
  const inputsRef = useRef([]);

  const [token, setToken] = useState(null);


  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("forgot_password_token"));

    if (token) {
     
      setToken(token); 
    
    }
    
    // Le tableau vide [] garantit que cette fonction s'exécute une seule fois (au 'montage')
  }, []);



  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // n’accepte que les chiffres
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.some((digit) => digit === "")) {
      setError("Veuillez saisir les 6 chiffres du code.");
      return;
    }

    const code = otp.join("");

    const payload = {
        code: code,
        token: token
    }

    console.log("PAYLOAD: ", payload);

    dispatch(onVerifyForgetPassword({payload,history: props.router.navigate}));
    
    

  };

 

  const dispatch = useDispatch();

  const handleResendForgetPasswordCode = async (e) => {


    e.preventDefault();
    
    console.log("ON RESEND ");
    dispatch(onResendForgetPasswordCode(token));
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="20"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="20"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                {/*<p className="mt-3">React Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Vérifiez votre email</h4>
                        <p className="mb-5">
                          Veuillez saisir le code à 6 chiffres envoyé dans votre email.
                          {/* à{" "}
                          <span className="fw-semibold">
                            www.yetaplus.com
                          </span>*/}
                        </p>

                        <Form onSubmit={handleSubmit}>

                          
                          <Row className="justify-content-center mb-3">
                              {otp.map((digit, index) => (
                                <Col key={index} className="col-2">
                                  <Input
                                    type="text"
                                    className="form-control form-control-lg text-center two-step"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    ref={(el) => (inputsRef.current[index] = el)}
                                  />
                                </Col>
                              ))}
                          </Row>

                          {error && <p className="text-danger">{error}</p>}
                          <Button color="success" type="submit" className="w-100">
                            Confirmer
                          </Button>
                   
                        </Form>

                        <div className="mt-4">
                         
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Vous n'avez pas reçu de code ?{" "}
                  {/*
                  <a href="#" className="fw-medium text-primary">
                    {" "}
                    Renvoyer{" "}
                  </a>{" "}

                  */}

                  <Link
                    to="#"
                    
                    onClick={(e) => {
                       
                      handleResendForgetPasswordCode(e);
                    }}
                   
                >RENVOYER</Link>
                </p>
                <p>
                  © {new Date().getFullYear()} YETA+. Développez avec{" "}
                  <i className="mdi mdi-heart text-danger"></i> par TECH ZENITH
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}
//export default AcceptInvitation;
export default withRouter(VerifyForgetPassword);

VerifyForgetPassword.propTypes = {
  history: PropTypes.object,
};
